var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type == 2)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.telConfirm}},[_vm._v(_vm._s(_vm.note))]):_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.telConfirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }